import { ReactComponent as FilterClockIcon } from "../../assets/icons/clock.svg";
import { useEffect, useState } from "react";
import ReportTable from "./ReportTable";
import { ReportCard } from "./components/ReportCard";
import SearchView from "./components/SearchView";
import FilterView from "./components/FilterView";
import { api } from "../../services/api";
import { useQuery } from "@tanstack/react-query";
import { useApp } from "../../services/app-context";
import { NotificationButton } from "../../components/NotificationButton";
import { SelectInput } from "../../components/SelectInput/SelectInput";

const filterList = (list: any[], search: string) => {
    return list.filter((item) => item?.name?.toLowerCase().includes(search.toLowerCase()) || item?.cohort?.toLowerCase().includes(search.toLowerCase()));
}

export default function EngagementReport() {
    const { tenantProfile } = useApp();
    const cohorts = tenantProfile?.groups;

    const [search, setSearch] = useState<string>('');
    const [selectedFilters, setSelectedFilters] = useState<any>({
        days: 3,
        quarter: false,
        startDate: '',
        endDate: '',
        hasComplete: false,
        hasIncomplete: false,
        cohort: '',
        sortBy: '',
        sortDirection: 'ASC',
    });

    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['engagement-report', selectedFilters],
        queryFn: () => api.getEngagementReport(selectedFilters),
    });

    const handleFilter = (form: any) => {
        setSelectedFilters(form);
    }

    const list = filterList(data?.data?.list || [], search);
    const summary = data?.data?.summary || {};

    const handleSort = (sortBy: string) => {
        setSelectedFilters(prev => {
            if (prev.sortBy === sortBy) {
                if (prev.sortDirection === 'DESC') {
                    return { ...prev, sortBy: '', sortDirection: 'ASC' };
                }
                return { ...prev, sortDirection: 'DESC' };
            }
            return { ...prev, sortBy, sortDirection: 'ASC' };
        });
    }

    useEffect(() => {
        refetch()
    }, [selectedFilters]);

    return (
        <div className="p-6 flex flex-col gap-4">
            <div className="flex items-center justify-between">
                <div className="flex flex-col gap-1">
                    <div className="text-black text-2xl font-semibold">PraxisPro Engagement Report</div>
                    <div className="justify-start text-black text-lg font-normal">View how your users are utilizing PraxisPro</div>
                </div>
                <NotificationButton />
            </div>
            <div className="flex gap-4 h-[calc(100vh-130px)]">
                <div className="flex flex-col gap-3">
                    <SearchView value={search} onChange={(e) => setSearch(e.target.value)} />
                    <ReportCard value={summary.activeUsers} label="Active Licenses" />
                    <ReportCard value={summary.total} label="Total Sessions" />
                    <ReportCard value={summary.completed} label="Completed Sessions" />
                    <ReportCard value={summary.incompleted} label="Incomplete Sessions" />

                </div>
                <div className="flex-1 flex flex-col h-full">
                    <div className="flex items-center gap-2">
                        <div className="w-[175px] h-[45px] bg-white rounded-[6px] px-2 py-2 outline-none flex items-center gap-[2px]">
                            <FilterClockIcon className="w-5 h-5 [&_path]:stroke-[#1A1A1A] [&_path]:stroke-2" />
                            <SelectInput 
                                containerClassName="w-full"
                                options={[
                                    { label: "Custom", value: "" },
                                    { label: "Last 3 days", value: "3" },
                                    { label: "Last 7 days", value: "7" },
                                    { label: "Last 30 days", value: "30" },
                                    { label: "Last 90 days", value: "90" },
                                ]}
                                placeholder="Select Days"
                                className="w-full h-full outline-none !border-none" 
                                value={selectedFilters.days} 
                                onChange={(e) => handleFilter({ ...selectedFilters, days: e.target.value })} 
                            />
                        </div>
                        <FilterView cohorts={cohorts || []} onFilter={handleFilter} />
                    </div>
                    <div className="mt-4 flex-1">
                        <ReportTable data={list} cohorts={cohorts} isLoading={isLoading} error={error} sortBy={selectedFilters.sortBy} sortDirection={selectedFilters.sortDirection} onSort={(sortBy) => handleSort(sortBy)} />
                    </div>
                </div>
            </div>
        </div>
    )
}